import { useIntl } from '@/intl'
import { pricesResponseSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { Dot, tk, Typography } from '@sunwebgroup/ui-components'
import { css, styled } from 'styled-components'

const LegendItem = styled.div<{ $isBestValue: boolean }>`
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  ${({ $isBestValue }) =>
    $isBestValue
    && css`
      ${Typography} {
        color: ${tk('color_semantic_icon_success')};
      }
    `}

  ${Dot} {
    margin-right: ${tk('spacing_md')};
  }
`

const PricesDescription = styled(Typography)`
  font-style: italic;
`

export function Legend() {
  const intl = useIntl()
  const { highlightInfo } = usePricesSelector(pricesResponseSelector)

  if (!highlightInfo) {
    return null
  }

  return (
    <div>
      {highlightInfo.map(highlight => (
        <LegendItem key={highlight.code} $isBestValue={highlight.isBestValue ?? false}>
          <Dot $color={highlight.hexColor} />
          <Typography $variant="body-xs-bold">{highlight.description}</Typography>
        </LegendItem>
      ))}
      <PricesDescription $variant="body-xs">
        {intl.formatMessage({ id: 'prices_grid_best_prices-description' })}
      </PricesDescription>
    </div>
  )
}
